import { render, staticRenderFns } from "./FieldSets.vue?vue&type=template&id=b22e14c6&scoped=true"
import script from "./FieldSets.vue?vue&type=script&lang=js"
export * from "./FieldSets.vue?vue&type=script&lang=js"
import style0 from "./FieldSets.vue?vue&type=style&index=0&id=b22e14c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e14c6",
  null
  
)

export default component.exports